module.exports = __webpack_public_path__ + "static/Averta-Bold-8bd51e54b0e125e178bca1747647649b.ttf";